module.exports = __webpack_public_path__ + "assets/img/moto.1ddf142e.svg";